<div class="row">
	<div class="col-md-12">
		<div *ngIf="statsBeneficiaire.length > 0" class="row text-center mt-5 mb-4">
			<span class="theme-main-color fw-bold fs-3">
				Statistiques par bénéficiaire
			</span>
		</div>
		<div class="row mt-4 mb-4">
			<div class="col-12 d-flex justify-content-end">
				<button
					class="btn theme-green-button"
					(click)="downloadStatsPdf('beneficiaire')"
				>
					Télécharger le rapport
				</button>
			</div>
		</div>
		<app-activity-report-detail
			*ngIf="statsBeneficiaire.length > 0"
			[statsEmployee]="statsBeneficiaire"
			[categorie]="categorie"
			[reportType]="'Bénéficiaire'"
		>
		</app-activity-report-detail>

		<div class="row text-center mt-5 mb-4" *ngIf="statsEmployee.length > 0">
			<span class="theme-main-color fw-bold fs-3">
				Statistiques par intervenant
			</span>
		</div>
		<div class="row mt-4 mb-4" *ngIf="statsEmployee.length > 0">
			<div class="col-4">
				<div class="input-group theme-main-color" *ngIf="isSESSAD">
					<label
						class="input-group-text theme-main-color"
						for="inputGroupSelect02"
						>Catégorie</label
					>
					<select
						[(ngModel)]="categorie"
						class="form-select"
						id="inputGroupSelect02"
					>
						<option selected value="0">Tous</option>
						<option value="1">LPC</option>
						<option value="2">LSF</option>
						<option value="3">Prise de notes</option>
						<option value="4">Oral</option>
					</select>
				</div>
			</div>
			<div class="col-8 d-flex justify-content-end">
				<button
					class="btn theme-green-button"
					(click)="downloadStatsPdf('intervenant')"
				>
					Télécharger le rapport
				</button>
			</div>
		</div>
		<app-activity-report-detail
			*ngIf="statsEmployee.length > 0"
			[statsEmployee]="statsEmployee"
			[categorie]="categorie"
			[reportType]="'Employee'"
		>
		</app-activity-report-detail>
	</div>
</div>

<div *ngIf="!isReportByMonth && dailyReports.length > 0">
	<div class="row text-center mt-5 pb-5">
		<span class="theme-main-color fw-bold fs-3">
			Statistiques journalières
		</span>
	</div>
	<table class="table">
		<caption></caption>
		<thead>
			<tr class="text-center">
				<th scope="col">Date</th>
				<th scope="col">Nbr de missions</th>
				<th scope="col">Nbr d'intervenant</th>
				<th scope="col">Distance parcourue</th>
				<th scope="col">Temps de trajet</th>
				<th scope="col">Temps de service</th>
				<th scope="col">Temps total</th>
				<th scope="col">Temps supp.</th>
				<th scope="col">Temps inutilisé</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let report of dailyReports" class="text-center">
				<th scope="row">{{ report.date | date : 'dd/MM/y' }}</th>
				<td>{{ report.numberOfMission }}</td>
				<td>{{ report.numberOfEmployee }}</td>
				<td>{{ report.distanceInKm | number : '1.2-2' }}km</td>
				<td>{{ report.travelTimeInMin | minutesToTime }}</td>
				<td>{{ report.serviceTimeInMin | minutesToTime }}</td>
				<td>
					{{ report.travelTimeInMin + report.serviceTimeInMin | minutesToTime }}
				</td>
				<td>{{ report.extraTimeInMin | minutesToTime }}</td>
				<td>{{ report.unusedTimeInMin | minutesToTime }}</td>
			</tr>
		</tbody>
	</table>
</div>
